<template>
    <div id='tm_right_section_wrapper'>
        <ul class="nav nav-tabs" style="margin-bottom: 0">
            <li class="active">
                <a href="#variables" data-toggle="tab" aria-expanded="true" v-text="$lang.get('trans.variables')"></a>
            </li>
            <li>
                <a href="#functions" data-toggle="tab" aria-expanded="false" v-text="$lang.get('trans.functions')"></a>
            </li>
            <li>
                <a href="#options" data-toggle="tab" aria-expanded="false" v-text="$lang.get('trans.page_options')"></a>
            </li>
        </ul>
        <div class="tab-content">
            <div class="tab-pane fade active in" id="variables">
                <variable-list :variables="variables" @insert="insertVariable"> </variable-list>
            </div>
            <div class="tab-pane fade" id="functions">
                <function-list @insert="insertFunction"> </function-list>
            </div>
            <div class="tab-pane fade" id="options">
                <paper-settings :options="options"></paper-settings>
            </div>
        </div>
    </div>

</template>

<script>
    import VariableList from './VariableList'
    import FunctionList from './FunctionList'
    import PaperSettings from './PaperSettings'

    export default {
        name: "template-options",

        components: {
            VariableList,
            FunctionList,
            PaperSettings
        },

        props: {
            variables: {
                required: true
            },
            options: {
                required: true
            }
        },

        data() {
            return {
                windowResizeListenerHandler: null
            }
        },

        methods: {
            insertVariable({variable}) {
                this.$emit('insert-variable', {
                    variable: variable
                })
            },

            insertFunction({func}) {
                this.$emit('insert-function', {
                    func: func
                })
            },

            windowResizeListener() {                
                var $list = $('.variable-list');
                $list.height($(window).height() - 200);

                $('#tm_right_section_wrapper').width($list.parents('#tm_right_section').width());                
            }            
        },

        destroy() {
            $(window).unbind('resize', this.windowResizeListenerHandler)
        },

        mounted() {
            this.windowResizeListenerHandler = _.debounce(this.windowResizeListener, 50);
            
            $(document).ready(() => {
                $(window).resize(this.windowResizeListenerHandler);
                $(window).trigger('resize');
            })
        }
    }
</script>

<style type='text/css'>
#tm_right_section_wrapper {
    position: fixed;
}

#variable-list {    
    overflow-y: scroll;
}
.variable-group {
    margin-bottom: 10px;
}
.variable-group h4 {
    text-align: center;
    padding: 10px 0;
    background-color: #ededed;
    margin-top: 0;
    position: -webkit-sticky;
    position: sticky;
    top: -1px;
    z-index: 55;    
}
.array-list-item {    
    border: solid 1px #ccc;
    margin-top: 5px;
    background-color: #f5f5f5;
    margin-left: 10px;
    margin-right: 10px;
}

.variable-group h5 {
    margin-top: 0;
    margin-bottom: 20px;
}

.array-list-item.disabled .btn.btn-outline.dark,
.array-list-item.disabled {
    border-color: #aaa;
    color: #aaa;
    cursor: not-allowed!important;
}

.array-list-item.disabled small {
    color: black;
}


</style>